import React from 'react';

interface IProps {
  object: any;
}

const JsonDisplay: React.FC<IProps> = ({ object }: IProps) => {
  return (
    <React.Fragment>
      <pre>{JSON.stringify(object, null, 2)}</pre>
    </React.Fragment>
  );
};

export default JsonDisplay;
